module.exports = __webpack_public_path__ + "img/rsvp-preview.9f5024e.jpg";